import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import Global from '../../../../store/global-selectors';
import { openLtlWizard } from '../../../../store/ltl/ltl.actions';
import { freightActionButtonMessages } from './messages';

import style from '../../../../components/grid-header/shared-classes.module.less';

export const NewQuoteButton = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const providers = useSelector(Global.selectFreightSettingsProviders);
  const hasConnectedProvider = providers.some((provider) => provider.isConnected);

  const handleClick = useCallback(() => {
    dispatch(openLtlWizard());
  }, [dispatch]);

  return (
    <Button
      className={style['action-button']}
      disabled={!hasConnectedProvider}
      onClick={handleClick}
      theme={THEME_CONSTANTS.primary}
      disabledTooltipMessage={!hasConnectedProvider ? intl.formatMessage(freightActionButtonMessages.newQuoteDisabledTooltip) : undefined}
    >
      <FormattedMessage {...freightActionButtonMessages.newQuote} />
    </Button>
  );
};
